<template>
  <div :class="['rb-step', { 'rb-active': active }]">
    <div
      class="rb-step-ios-data medium--hide large--hide"
      v-if="displayProductTitle"
    >
      <h2>{{ product.title }}</h2>
      <diamond-data mode="subscriber" :gia="true" :editable="true" />
    </div>
    <h2 class="rb-step-product-title" v-if="displayProductTitle">
      {{ product.title }}
    </h2>
    <diamond-data
      mode="subscriber"
      :gia="true"
      :editable="true"
      class="small--hide"
    />
    <div class="rb-step-header">
      <div>
        <h2>{{ data.label }}</h2>
        <span v-if="displayStepValue">:&nbsp;{{ stepValue }}</span>
      </div>
      <div class="rb-step-header-controls">
        <view-controls label="View" />
        <sku-search :selected-options="selectedOptions" :mappings="mappings" />
        <step-help
          :show-help-title="data.helpTitle !== ''"
          :help-title="data.helpTitle"
          :show-label="true"
          :label="data.label"
          :popup-id="data.popupId"
        />
      </div>
      <div class="rb-step-appointment">
        <span>Make an <a class="link" href="/pages/contact?source=erb">appointment</a> with a diamond advisor</span>
      </div>
    </div>
    <div class="rb-step-content">
      <step-choices
        :data="data"
        v-if="data.type === 'options-images' || data.type === 'options-text'"
        :selected-options="selectedOptions"
        :product="product"
        :mappings="mappings"
        :availability="availability"
      />
      <step-input
        :data="data"
        v-if="data.type === 'input-text'"
        :selected-options="selectedOptions"
      />
      <step-diamond
        :data="data"
        v-if="data.type === 'diamond-selector'"
        :selected-options="selectedOptions"
        :diamonds-data="diamondsData"
        :diamonds-meta="diamondsMeta"
        :selectors="selectors"
        :api="api"
        :mappings="mappings"
        :combine-price="combinePrice"
        :enable-v360="enableV360"
      />
      <step-confirm
        :data="data"
        v-if="data.type === 'summary'"
        :selected-options="selectedOptions"
        :product="product"
        :mappings="mappings"
        :api="api"
        :url-shop="urlShop"
        :social-share="socialShare"
      />
    </div>
  </div>
</template>
<script>
/**
 * Step wrapper with navigation and components that are no step specific
 *
 * @props
 * api: Object
 * active: Boolean
 * selectors: Boolean
 * product: Object
 * mappings: Object
 * availabilty: Array
 * urlShop: String
 * socialShare: Object
 *
 * @implements
 * ChildMixin
 * DiamondsMixin
 * CommMixin
 *
 *
 */
import ChildMixin from "@/mixins/ChildMixin";
import DiamondsMixin from "@/mixins/DiamondsMixin";
import CommMixin from "@/mixins/CommMixin";
import StepChoices from "@/components/StepChoices";
import StepInput from "@/components/StepInput";
import StepDiamond from "@/components/StepDiamond";
import StepConfirm from "@/components/StepConfirm";
import ViewControls from "@/components/ViewControls";
import DiamondData from "@/components/DiamondData";
import StepHelp from "@/components/StepHelp";
import SkuSearch from "@/components/SkuSearch";
export default {
  components: {
    StepChoices,
    StepInput,
    StepDiamond,
    StepConfirm,
    ViewControls,
    DiamondData,
    StepHelp,
    SkuSearch,
  },
  mixins: [ChildMixin, DiamondsMixin, CommMixin],
  props: {
    api: {
      type: Object,
    },
    active: {
      type: Boolean,
      default: false,
    },
    selectors: {
      type: Boolean,
      default: true,
    },
    product: {
      type: Object,
    },
    mappings: {
      type: Object,
    },
    availability: {
      type: Array,
    },
    urlShop: {
      type: String,
    },
    socialShare: {
      type: Object,
    },
    combinePrice: {
      type: Boolean,
      default: true,
    },
    enableV360: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stepValue: function () {
      var labelChoice =
        this.selectedOptions.find(
          (selectedOption) => selectedOption.step.id === this.data.id
        )?.choice || "";

      return labelChoice
        ? labelChoice.labelDisplay
          ? labelChoice.labelDisplay
          : labelChoice.label
        : "";
    },
    displayStepValue: function () {
      return (
        this.stepValue &&
        (this.data.type === "options-images" ||
          this.data.type === "options-text")
      );
    },
    displayProductTitle: function () {
      return this.data.id !== "diamond" && this.data.id !== "summary";
    },
  },
};
</script>
